import type { ReactElement } from 'react';

import { PyramidLoader } from '../ui/PyramidLoader';

const SIZE_PX = 80;
const STROKE_PX = 3;

export const PanelLoader = (): ReactElement => (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <PyramidLoader
            sizePx={SIZE_PX}
            strokePx={STROKE_PX}
            className="text-occ-foreground-100"
        />
    </div>
);
